import { ALIGN_HORIZONTAL } from "../../../actions/index";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case ALIGN_HORIZONTAL:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          if (
            old_layer.width > 0 &&
            (old_layer.allow_image || old_layer.allow_text)
          ) {
            const layerWidth = old_layer.width;

            // Get furthest right edge of text elements
            const rightMostText = Math.max.apply(
              Math,
              old_layer.text_elements.map((obj) => {
                return obj.width + obj.left_position;
              }),
            );
            // Get furthest right edge of image elements
            const rightMostImage = Math.max.apply(
              Math,
              old_layer.image_elements.map((obj) => {
                return obj.width + obj.left_position;
              }),
            );
            // Right edge of bounding box
            const rightEdge =
              rightMostText > rightMostImage ? rightMostText : rightMostImage;

            // Get furthest left edge of text elements
            const leftMostText = Math.min.apply(
              Math,
              old_layer.text_elements.map((obj) => {
                return obj.left_position;
              }),
            );
            // Get furthest left edge of text elements
            const leftMostImage = Math.min.apply(
              Math,
              old_layer.image_elements.map((obj) => {
                return obj.left_position;
              }),
            );
            // Left edge of bounding box
            const leftEdge =
              leftMostText < leftMostImage ? leftMostText : leftMostImage;

            const boundingBox = rightEdge - leftEdge,
              newLeftOfBoundingBox = (layerWidth - boundingBox) / 2,
              delta = newLeftOfBoundingBox - leftEdge;

            return {
              ...old_layer,
              text_elements: old_layer.text_elements.map((element) => {
                let newLeft = element.left_position + delta;
                const totalElWidth = element.width + newLeft;

                // If outside the bounds of the printable area, move it back within bounds
                if (totalElWidth > layerWidth) {
                  newLeft = layerWidth - element.width;
                } else if (newLeft < 0) {
                  newLeft = 0;
                }

                return {
                  ...element,
                  left_position: newLeft,
                };
              }),
              image_elements: old_layer.image_elements.map((element) => {
                let newLeft = element.left_position + delta;
                const totalElWidth = element.width + newLeft;

                // If outside the bounds of the printable area, move it back within bounds
                if (totalElWidth > layerWidth) {
                  newLeft = layerWidth - element.width;
                } else if (newLeft < 0) {
                  newLeft = 0;
                }

                return {
                  ...element,
                  left_position: newLeft,
                };
              }),
            };
          } else {
            return {
              ...old_layer,
            };
          }
        }),
      };

    default:
      return state;
  }
}
